import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";

interface ProtectedRouteProps {
	redirectPath?: string;
	children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	redirectPath = "/login",
	children
}) => {
	const accessToken = useAuthStore((state) => state.accessToken);
	const resetAuth = useAuthStore((state) => state.resetAuth);
	const isAuthenticated = !!accessToken;

	useEffect(() => {
		if (!accessToken) {
			resetAuth();
		}
	}, [resetAuth, accessToken]);

	if (!isAuthenticated) {
		return <Navigate to={redirectPath} replace />;
	}

	return children || <Outlet />;
};

export default ProtectedRoute;
